







































import { TemplateInterface, TemplateStatus } from "@/interfaces/template.interface";
import ToastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import axios from "@/libs/axios";
// @ts-ignore
import i18n from "@/libs/i18n";

// @ts-ignore
import router from "@/router";
import WhatsAppTemplateForm from "@/views/modules/settings/whatsapp-templates/components/whatsAppTemplateForm.vue";
import useTemplatesList from "@/views/modules/settings/whatsapp-templates/useTemplatesList";
import { defineComponent, ref } from "@vue/composition-api";
import { BBadge, BCol, BContainer, BLink, BRow, VBTooltip } from "bootstrap-vue";
import { useToast } from "vue-toastification/composition";

export default defineComponent({
    components: {
        BCol,
        BContainer,
        BLink,
        BRow,
        BBadge,
        WhatsAppTemplateForm,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup() {
        const toast = useToast();
        const { getTranslatedError } = useTemplatesList();

        const templateId = router.currentRoute.params.id;
        const template = ref<Partial<TemplateInterface>>();

        axios.get(`templates/${templateId}`, { params: { join: "channels" } }).then((response) => {
            template.value = response.data;
        });

        const isLoading = ref("");

        const getVariantByStatus = (status: TemplateStatus) => {
            switch (status.toLowerCase()) {
                case TemplateStatus.APPROVED:
                    return "success";
                case TemplateStatus.REJECTED:
                    return "danger";
                case TemplateStatus.PAUSED:
                    return "warning";
                default:
                    return "status-default";
            }
        };

        const updateTemplate = (template: Partial<TemplateInterface>, submitForApproval = false) => {
            isLoading.value = submitForApproval ? "submit" : "save";
            axios
                .patch(
                    `templates/${templateId}`,
                    {
                        ...template,
                        channels: template.channels.map((channel) => ({ id: channel.id })),
                    },
                    { params: { "submit-for-approval": submitForApproval } }
                )
                .then(() => {
                    toast(
                        {
                            component: ToastificationContent,
                            props: {
                                title: i18n.t("settings.templates.whatsapp.edit.success"),
                                text: submitForApproval
                                    ? i18n.t("settings.templates.whatsapp.edit.success-description")
                                    : i18n.t("settings.templates.whatsapp.edit.success"),
                                icon: "check",
                                variant: "success",
                            },
                        },
                        {
                            timeout: 10000,
                        }
                    );

                    router.push({ name: "settings-whatsapp-templates" });
                })
                .catch((error) => {
                    toast(
                        {
                            component: ToastificationContent,
                            props: {
                                title: i18n.t("settings.templates.whatsapp.edit.failed"),
                                text: getTranslatedError(error.response?.data?.message),
                                icon: "times",
                                variant: "danger",
                            },
                        },
                        {
                            timeout: 10000,
                        }
                    );
                })
                .finally(() => {
                    isLoading.value = "";
                });
        };

        return {
            isLoading,
            template,
            updateTemplate,
            getVariantByStatus,
        };
    },
});
